import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export type OdinFormErrorProps = {
  error?: string
  id?: string
  className?: string
}

export function OdinFormError({ error, id, className }: OdinFormErrorProps) {
  const { t } = useTranslation()
  if (!error) return null
  return (
    <p id={id} role="alert" className={cn('text-xs text-destructive animate-in fade-in', className)}>
      {t(error)}
    </p>
  )
}
